<template>
    <div class="cms-container mb-4">
        <ToastCMS ref="toast" />
        <!-- PREVIEW IMAGE -->
        <div v-if="showPreviewModal" class="preview-modal w-100 h-100 d-flex align-items-center justify-content-center"
            @click.self="closePreviewImage">
            <div class="d-block-align-items-center justify-content-center w-100 mx-3">
                <div class="modal-content bg-transparent position-relative border-0">
                    <button class="close-btn position-fixed text-white bg-transparent border-0"
                        @click="closePreviewImage">&times;</button>

                    <div class="d-flex justify-content-between align-items-center border-0">
                        <video v-if="previewIsVideo" :src="previewImages[currentPreviewIndex]" controls muted
                            style="max-width:70vw; max-height:70vh; display:block; margin:0 auto;"></video>
                        <img v-else :src="previewImages[currentPreviewIndex]" alt="Preview Image">
                    </div>
                </div>

                <div v-if="previewImages.length > 1" class="text-center mt-3">
                    <span class="text-white">Image {{ currentPreviewIndex + 1 }} of {{ previewImages.length }}</span>
                </div>
            </div>
        </div>

        <div class="sticky-controls">
            <div class="main-header d-flex align-items-center justify-content-between px-3"
                :class="{ 'drop-active': dragOver }" @dragover.prevent="dragOver = true" @dragleave="dragOver = false"
                @drop.prevent="handleDrop">
                <div class="career-header text-dark">
                    Career
                    <span v-if="dragOver" class="ml-2 text-primary" style="font-size: 14px;">(Drop images here)</span>
                </div>
                <div class="d-flex gap-2">
                    <input type="file" ref="bulkInput" multiple accept="image/*" hidden @change="handleBulkUpload">
                    <button type="button" @click="$refs.bulkInput.click()"
                        class="vmc-bg-prime-4 border-0 text-white rounded px-2 py-1">
                        Add Image(s)
                    </button>
                </div>
            </div>
        </div>

        <!-- BACKGROUND MEDIA — separate from image list -->
        <div class="px-3">
            <div class="mt-3">
                <div class="d-flex align-items-center justify-content-between w-100 my-2">
                    <div class="d-flex align-items-center justify-content-between w-100 mt-2">
                        <span class="career-number text-dark">
                            Background Media (MP4 or Image, Max 10MB)
                        </span>
                        <div class="d-flex align-items-center" style="gap:5px;">
                            <button type="button" @click="previewBgMedia"
                                class="vmc-bg-prime-4 text-white rounded px-3 py-1 border-0">
                                View
                            </button>
                        </div>
                    </div>
                </div>
                <div class="img-placeholder-box" @click="openBgInput">

                    <video v-if="careerBackgroundVideo" :src="careerBackgroundVideo" class="w-100 h-100" controls muted
                        style="object-fit:contain;"></video>
                    <img v-else-if="careerBackgroundImage" :src="careerBackgroundImage" class="w-100 h-100"
                        style="object-fit:contain;">

                    <template v-else>
                        <div class="w-100 h-100 d-flex flex-column justify-content-center align-items-center text-center"
                            style="cursor:pointer;">
                            <i class="material-symbols-outlined">upload</i>
                            <span>Upload Background (MP4 or Image)</span>
                        </div>
                    </template>
                    <input type="file" id="upload-career-bg" accept="video/mp4, image/png, image/jpeg, image/jpg" hidden
                        @change="onBgMediaChange($event)">
                </div>
                <button @click="removeBgMedia" type="button"
                    class="w-100 vmc-bg-prime-6 py-1 text-white mt-1 border-0 rounded">
                    Remove Media
                </button>
            </div>
        </div>

        <form action="" id="career" @submit.prevent="saveAllChanges">
            <div class="pb-3">
                <div class="grid-header">
                    <div class="w-100 mt-4" v-for="(container, index) in containers" :key="index">
                        <div class="d-flex px-3 align-items-center justify-content-between w-100 mt-2">
                            <span class="career-number text-dark">
                                Career Image # {{ index + 1 }}
                            </span>
                            <div class="d-flex align-items-center" style="gap:5px;">
                                <button type="button" @click="previewImage(index)"
                                    class="vmc-bg-prime-4 text-white rounded px-3 py-1 border-0">
                                    View
                                </button>
                            </div>
                        </div>
                        <div class="mt-2 px-3">
                            <div class="img-placeholder-box" @click="triggerSingleUpload(index)">
                                <img v-if="container.image" :src="container.image" alt=""
                                    style="height:100%; width:100%; object-fit:contain;">
                                <template v-else>
                                    <div class="w-100 h-100 d-flex flex-column justify-content-center align-items-center text-center"
                                        style="cursor:pointer;">
                                        <i class="material-symbols-outlined">upload</i>
                                        <span>Upload Photo</span>
                                    </div>
                                </template>
                                <input type="file" :ref="'file_' + index" accept="image/png, image/jpeg, image/jpg"
                                    hidden @change="onImageChange($event, index)">
                            </div>
                            <button @click="removeContainer(index)" type="button"
                                class="vmc-bg-prime-6 w-100 text-white rounded px-2 py-1 border-0">
                                Remove
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
        <div class="px-3 mt-4">
            <button type="submit" form="career" class="vmc-bg-prime-4 border-0 text-white rounded px-3 py-1"
                :disabled="!hasChanges">
                Save All Changes
            </button>
        </div>
    </div>
</template>

<script>
import ToastCMS from '../ToastCMS.vue';
export default {
    name: "CareerCMS",
    components: {
        ToastCMS
    },
    data() {
        return {
            containers: [],
            originalContainers: [],
            careerBackgroundVideo: '',
            careerBackgroundImage: '',
            originalCareerBgVideo: '',
            originalCareerBgImage: '',
            previewImages: [],
            previewIsVideo: false,
            showPreviewModal: false,
            currentPreviewIndex: 0,
            dragOver: false
        }
    },
    methods: {
        triggerSingleUpload(index) {
            const input = this.$refs['file_' + index];
            if (input && input[0]) input[0].click();
        },

        handleBulkUpload(e) {
            const files = Array.from(e.target.files);
            this.processFiles(files);
            e.target.value = '';
        },

        handleDrop(e) {
            this.dragOver = false;
            const files = Array.from(e.dataTransfer.files);
            this.processFiles(files);
        },

        async processFiles(files) {
    const validImages = files.filter(f => f.type.startsWith("image/"));
    if (validImages.length === 0) return;

    for (const file of validImages) {
        const formData = new FormData();
        formData.append('image', file);

        try {
            const response = await fetch('/vmc/api/upload', {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('vmc_token')}`
                },
                body: formData
            });

            const data = await response.json();

            if (response.ok) {
                this.containers.push({ image: data.url });
            } else {
                console.error("Upload failed:", data.message);
            }
        } catch (error) {
            console.error("Upload error:", error);
        }
    }
    this.$refs.toast.showToast(`${validImages.length} images added`, "success");
},

        removeContainer(index) {
            this.containers.splice(index, 1);
            this.$refs.toast.showToast(`Career Image ${index + 1} removed`, "error");
        },

        async onImageChange(e, index) {
    const file = e.target.files[0];
    if (file && file.type.startsWith("image/")) {
        const formData = new FormData();
        formData.append('image', file);

        try {
            const response = await fetch('/vmc/api/upload', {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('vmc_token')}`
                },
                body: formData
            });

            const data = await response.json();

            if (response.ok) {
                this.$set(this.containers[index], 'image', data.url);
                this.$refs.toast.showToast(`Image attached`, "success");
            } else {
                console.error("Upload failed:", data.message);
            }
        } catch (error) {
            console.error("Upload error:", error);
        }
    }
    e.target.value = "";
},

        previewImage(index) {
            if (!this.containers[index].image) {
                this.$refs.toast.showToast("No images to view", "warning");
                return;
            }
            this.previewImages = [this.containers[index].image];
            this.previewIsVideo = false;
            this.currentPreviewIndex = 0;
            this.showPreviewModal = true;
        },

        openBgInput() {
            const input = document.getElementById('upload-career-bg');
            if (input) input.click();
        },

        async onBgMediaChange(e) {
    const file = e.target.files[0];
    if (!file) return;

    if (file.size > 10 * 1024 * 1024) {
        this.$refs.toast.showToast("File is too large! Max 10MB.", "error");
        e.target.value = "";
        return;
    }

    const formData = new FormData();
    formData.append('image', file);

    try {
        const response = await fetch('/vmc/api/upload', {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('vmc_token')}`
            },
            body: formData
        });

        const data = await response.json();

        if (response.ok) {
            if (file.type.startsWith('video/')) {
                this.careerBackgroundVideo = data.url;
                this.careerBackgroundImage = '';
            } else {
                this.careerBackgroundImage = data.url;
                this.careerBackgroundVideo = '';
            }
            this.$refs.toast.showToast("Background media attached", "success");
        } else {
            console.error("Upload failed:", data.message);
        }
    } catch (error) {
        console.error("Upload error:", error);
    }
    e.target.value = "";
},

        previewBgMedia() {
            if (!this.careerBackgroundVideo && !this.careerBackgroundImage) {
                this.$refs.toast.showToast("No background media to view", "warning");
                return;
            }
            if (this.careerBackgroundVideo) {
                this.previewImages = [this.careerBackgroundVideo];
                this.previewIsVideo = true;
            } else {
                this.previewImages = [this.careerBackgroundImage];
                this.previewIsVideo = false;
            }
            this.currentPreviewIndex = 0;
            this.showPreviewModal = true;
        },

        removeBgMedia() {
            if (!this.careerBackgroundVideo && !this.careerBackgroundImage) {
                this.$refs.toast.showToast("No background media to remove", "warning");
                return;
            }
            this.careerBackgroundVideo = '';
            this.careerBackgroundImage = '';
            this.$refs.toast.showToast("Background media removed", "error");
        },

        onKeyboard(e) {
            if (this.showPreviewModal && e.key === 'Escape') {
                this.showPreviewModal = false;
            }
        },

        closePreviewImage() {
            this.showPreviewModal = false;
            this.previewImages = [];
            this.previewIsVideo = false;
        },

        async loadFormData() {
            try {
                const token = localStorage.getItem('vmc_token');
                const response = await fetch(`${process.env.VUE_APP_API_URL}/api/content?_nocache=${new Date().getTime()}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                if (!response.ok) throw new Error("Failed to fetch content");
                const data = await response.json();
                if (data && Object.keys(data).length > 0) {
                    if (Array.isArray(data.careerImages)) {
                        this.containers = data.careerImages.map(c => ({ image: c.image || '' }));
                    }
                    this.careerBackgroundVideo = data.careerBackgroundVideo ?? '';
                    this.careerBackgroundImage = data.careerBackgroundImage ?? '';
                }
                this.originalContainers = JSON.parse(JSON.stringify(this.containers));
                this.originalCareerBgVideo = this.careerBackgroundVideo;
                this.originalCareerBgImage = this.careerBackgroundImage;
            } catch (error) {
                this.$refs.toast.showToast("Failed to load data!", "error");
            }
        },

        async saveAllChanges() {
            try {
                const token = localStorage.getItem('vmc_token');
                const response = await fetch(`${process.env.VUE_APP_API_URL}/api/update`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify({
                        careerImages: this.containers,
                        careerBackgroundVideo: this.careerBackgroundVideo,
                        careerBackgroundImage: this.careerBackgroundImage
                    })
                });
                if (!response.ok) throw new Error("Server error");
                this.originalContainers = JSON.parse(JSON.stringify(this.containers));
                this.originalCareerBgVideo = this.careerBackgroundVideo;
                this.originalCareerBgImage = this.careerBackgroundImage;
                this.$refs.toast.showToast("Saved all changes.", "success");
                setTimeout(() => { window.location.reload(); }, 1500);
            } catch (error) {
                this.$refs.toast.showToast("Save failed. Check your connection.", "error");
            }
        }
    },

    async mounted() {
        window.addEventListener('keydown', this.onKeyboard);
        await this.loadFormData();
    },

    beforeDestroy() {
        window.removeEventListener('keydown', this.onKeyboard);
    },

    computed: {
        hasChanges() {
            return (
                JSON.stringify(this.containers) !== JSON.stringify(this.originalContainers) ||
                this.careerBackgroundVideo !== this.originalCareerBgVideo ||
                this.careerBackgroundImage !== this.originalCareerBgImage
            );
        }
    }
}
</script>

<style scoped>
.toast-container {
    position: fixed;
    top: 20px;
    right: 20px;
    width: 300px;
    z-index: 9999;
}

hr {
    border-top: 1px solid black;
}

.sticky-controls {
    position: sticky;
    z-index: 10;
    background: white;
    top: 60px;
}

.drop-active {
    background-color: #f0f8ff !important;
    border: 2px dashed var(--vmc-primary-4) !important;
}

.img-placeholder-box {
    height: 200px;
    width: 100%;
    background-position: center;
    border: 1px solid gray;
    margin-bottom: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    cursor: pointer;
}

@media (min-width: 330px) {
    .main-header {
        padding: 15px 0;
        border-top: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
    }

    .career-header {
        font-size: 17px;
        font-weight: 600;
    }

    .career-number {
        font-size: 18px;
        font-weight: 600;
    }

    .grid-header>div {
        width: 100%;
    }

    .preview-modal {
        position: fixed;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.8);
        z-index: 9999;
        overflow-y: hidden;
        overscroll-behavior: contain;
    }

    .modal-content img,
    .modal-content video {
        max-width: 70vw;
        max-height: 70vh;
        width: auto;
        height: auto;
        object-fit: contain;
        display: block;
        margin: 0 auto;
    }

    .close-btn {
        top: 10px;
        right: 15px;
        font-size: 24px;
        cursor: pointer;
    }
}

@media (min-width: 768px) {
    .career-header {
        font-size: 20px;
    }
}

@media (min-width: 992px) {
    .grid-header {
        display: flex;
        flex-wrap: wrap;
    }

    .grid-header>div {
        width: 50% !important;
        box-sizing: border-box;
    }

    .modal-content img,
    .modal-content video {
        max-height: 80vh;
    }
}

@media (min-width: 1200px) {
    .cms-container {
        margin-left: 310px;
        width: calc(100% - 310px);
        margin-top: 82px;
    }

    .sticky-controls {
        top: 82px;
    }
}
</style>